import { createRef, useCallback, useEffect, useState } from "react";
import { Button, Col, Form, Row } from "react-bootstrap";
import Loading from "../../loading/Loading";
import UserLayout from "../layout/UserLayout";
import SearchableSelect from "../../common/SearchableSelect";
import {
	apenasNumeros,
	cpf_cnpj_mask,
	cpf_mask,
	createFuncionario,
	getAllData,
	getFuncionarios,
	pis_mask,
	telefone_mask,
	updateTableNew,
} from "../../../services/Servicos";
import { useDispatch, useSelector } from "react-redux";
import {
	update,
	updateFiliaisList,
	updateFuncionarios,
} from "../../../redux/slicers/user";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import ModalErrorPretty from "../../modal/ModalErrorPretty";
import { getErrorMessage } from "../../../services/helpers";
import BotaoSalvar from "../../botoes/BotaoSalvar";

const nomeD = createRef(null);
const emailD = createRef(null);
const telefoneD = createRef(null);
const cpfD = createRef(null);
const cnhD = createRef(null);
const dataNascimentoD = createRef(null);
const dataValidadeCnh = createRef(null);
const userStatusD = createRef(null);
const senhaD = createRef(null);
const DescLocalSeparacaoD = createRef(null);
const pisD = createRef(null);

export default function VariaveisAmbiente() {

	const [body, setBody] = useState({
		appversion: "1.0.10"
	});
	const [error, setError] = useState({show: false, message: ""})
	const [loading, setLoading] = useState({message: "Atualizar", style:"primary"})

	const verifyAppVersion = useCallback(async () => {
		try {
			const {data} = await getAllData("mobile/gestao/version")

			setBody(last => ({...last, appversion: data.version ?? "error"}))
		} catch (error) {
			setError({show: true, message: getErrorMessage(error)})
		}
	}, [])
	const updateAppVersion = useCallback(async () => {
		setLoading({message: "Atualizando", style:"warning"})
		try {
			await updateTableNew("mobile/gestao/version", body)
		} catch (error) {
			setError({show: true, message: getErrorMessage(error)})
		}
		setLoading({message: "Atualizado", style:"success"})
		setTimeout(() => {
			setLoading({message: "Atualizar", style:"primary"})
		}, 1000)
	}, [body])
	
	useEffect(() => {
		verifyAppVersion()
	}, [])
	return (
		<UserLayout>
			<div className="variaveis-ambiente">
				<h3>Variáveis de Ambiente</h3>
				<br/>
				<Row>
					<Col sm='3'>
						<Form.Label>Versão do aplicativo móvel:</Form.Label>
						<div className="d-flex gap-2 flex-row">
							<Form.Control 
								value={body.appversion}
								onChange={(e) => setBody(last => ({...last, appversion: e.target.value }))}
							/>
							<BotaoSalvar fnRetorno={updateAppVersion} msg={loading.message} style={loading.style}/>
						</div>
					</Col>
				</Row>
			</div>
			{error.show ? <ModalErrorPretty setShow={setError} {...error} /> : ""}
		</UserLayout>
	);
}
